<template>
  <div class="official_page">

    <page-title v-bind="{...pT}" />
    <div class="page-main">
      <div class="official_page_type" v-for="item in typeList" :key="item.value"
           :class="tutorialType === item.value ? 'action': ''" @click="() =>setTutorialType(item)"
           v-text="item.label" />
      <div style="text-align: right">
        <a-button type="primary" @click="add">新增</a-button>
      </div>
    </div>
    <business-group ref="businessGroup" :formValues="formValues" :tableConfig="{...tableConfig}"
                    :formConfig="{...formConfig}">
      <template slot="action" slot-scope="record">
        <a-button type="link" @click="edit(record)">编辑</a-button>
        <a-button type="link" @click="del(record)">删除</a-button>
        <a-button type="link" @click="details(record)">查看详情</a-button>
      </template>
      <template slot="videoCover" slot-scope="record">
        <mVideo :title="record.tutorialName" :img-url="record.videoCover" :video-url="record.tutorialVideoUrl" />
      </template>
            <template slot="tutorialPrefix" slot-scope="record">
        <span v-html="record.tutorialPrefix" class="_anw" />
      </template>
    </business-group>

  </div>
</template>

<script>
import { confirm, tips } from "@/utils/util";
import pageTitle from "@/components/business/pageTitle";
import businessGroup from "@/components/business/businessGroup";
import mVideo from "@/components/business/mVideo/mVideo";

const columns = [
  {
    title: "名称",
    dataIndex: "tutorialName",
    key: "tutorialName",
    align: "center"
  },
  {
    title: "视频",
    dataIndex: "videoCover",
    key: "videoCover",
    align: "center",
    scopedSlots: { customRender: "videoCover" }
  },
  {
    title: "详情",
    dataIndex: "tutorialPrefix",
    key: "tutorialPrefix",
    align: "center",
    with:300,
    scopedSlots: { customRender: "tutorialPrefix" },
  },
  {
    title: "上传时间",
    dataIndex: "createTime",
    key: "createTime",
    align: "center"
  },
  {
    title: "操作",
    scopedSlots: { customRender: "action" },
    align: "center",
    width: 180
  }
];

export default {
  components: {
    pageTitle,
    businessGroup,
    mVideo
  },
  data() {
    return {
      pT: {},
      typeList: [
        { value: "COLOR_TEMPERATURE", label: "色温" },
        { value: "LIGHT_REPO", label: "光源库" },
        { value: "LIGHT_MATE", label: "光源匹配" },
        { value: "COLOR_TEMPERATURE_SLICE", label: "色温片" },
        { value: "COLOR_PAPER", label: "色纸" },
        { value: "HIS", label: "HSI" },
        { value: "RGB", label: "RGB" },
        { value: "COLOR_COORDINATE", label: "色坐标" },
        { value: "PICKER", label: "拾色器" },
        { value: "SYSTEM_LIGHT", label: "系统光效" },
        { value: "MAJOR_MANUAL", label: "专业手动" },
        { value: "LIGHT_PICKER", label: "光效拾取" }
      ],

      tableConfig: {
        columns,
        url: "bluetoothlight/web/other/tutorials",
        rowKey: "tutorialId"
      },
      formConfig: {
        formShow: false
      },
      formValues: {
        tutorialType: undefined
      },
      tutorialType: undefined,


      detailsUrl: undefined,
      saveUrl: undefined,

      pageLoading: false

    };
  },
  created() {
    this.tutorialType = this.typeList[0]?.value;
    this.formValues.tutorialType = this.tutorialType;
  },
  methods: {
    setTutorialType(item) {
      this.tutorialType = item.value;
      this.formValues.tutorialType = item.value;
      this.$refs?.["businessGroup"]?.getData?.();
    },
    details(record) {
      this.$router.push({
        path: "/official_details",
        query: {
          tutorialId: record?.tutorialId
        }
      });
    },
    del(record) {
      const tutorialId = record?.tutorialId;
      if (!tutorialId || this.pageLoading) return false;

      this.pageLoading = true;

      const payload = {
        okBack: async () => {

          const res = await this.$http("DELETE", `/bluetoothlight/web/other/tutorials/${tutorialId}`);
          const resultStatus = res?.resultStatus;
          if (resultStatus) {
            tips(this, true);
            this.refreshData();
          }
        },
        title: `确认删除该教程吗`
      };
      confirm(this, payload);
      setTimeout(() => {
        this.pageLoading = false;
      }, 400);
    },
    edit(record) {
      const { url, rowKey } = this.tableConfig;
      this.detailsUrl = `${url}/${record[rowKey]}`;
      this.saveUrl = `${url}/${record[rowKey]}`; // 详情的参数不一样 保存事件要抛出

      // console.log(this.detailsUrl);
      // console.log(this.saveUrl);
      this.$router.push({
        path: "/help_edit",
        query: {
          saveUrl: `${url}/${record[rowKey]}`,
          detailsUrl: `${url}/${record[rowKey]}`,
          detailsUrlFormValues: JSON.stringify({
            pageSize: 1
          }),
          editType: "video",
          backURl: "/official_list"

        }
      });

    },
    add(record) {
      const { url, rowKey } = this.tableConfig;
      this.detailsUrl = `${url}/${record[rowKey]}`;
      this.saveUrl = `${url}/${record[rowKey]}`; // 详情的参数不一样 保存事件要抛出
      this.$router.push({
        path: "/help_edit",
        query: {
          saveUrl: `${url}/0`,
          detailsUrlFormValues: JSON.stringify({
            pageSize: 1
          }),
          editType: "video",
          backURl: "/official_list",
          tutorialType: this.tutorialType

        }
      });

    },
    refreshData() {
      this.$refs?.["businessGroup"]?.getData?.();
    }
  }
};
</script>


<style lang="less" scoped>
._anw {
  // display: -webkit-box;
  // width: 400px;
  // overflow: hidden;
  // text-overflow: ellipsis;
  // white-space: nowrap;
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.official_page_type {
  cursor: pointer;
}

.official_page_type.action {
  color: #2a82e4;
  border-color: #2a82e4;
}

.official_page {
  .header {
    height: 86px;
    font-size: 24px;
    font-weight: 500;
    border-bottom: 1px solid #eee;
    margin-left: 5px;
  }

  &_type {
    width: 70px;
    height: 30px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border: 1px solid #E4E4E4;
    font-size: 12px;
    color: #E4E4E4;
    margin-top: 20px;
    text-align: center;
    line-height: 30px;
    display: inline-block;
  }

  .add {
    width: 80px;
    height: 30px;
    border-radius: 5px;
    background-color: #72CA96;
    color: #fff;
    border: none;
  }

  .avatar-url {
    width: 100px;
    height: 80px;
  }
}
</style>
